import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {Platform} from 'react-native';
import FastImage from '../../components/Interface/Images/FastImageWithFallback';
import { ScrollView } from 'react-native-gesture-handler';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;
  padding: 0 24px;
`;

//@ts-ignore
export const ContentScroll = styled(ScrollView)`
  margin: 0 -24px;
`;

export const PaymentsList = styled.View``;

export const Title = styled.Text`
  font-size: ${RFValue(18)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
`;

export const LimitsContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(12)}px;
  z-index: 2;
`;

export const LimitsText = styled.Text`
  font-size: ${RFValue(14)}px;
  flex: 1;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;


export const BannerContainer = styled.View`
margin-top: -${RFValue(12)}px;
`;

export const BannerButton = styled.TouchableOpacity`
  margin-bottom: ${RFValue(12)}px;
`;

//@ts-ignore
export const Banner = styled(FastImage)`
  width: 100%;
  height: ${RFValue(49)}px;
  border-radius: ${RFValue(12)}px;

  border:1px solid ${({theme}) => theme.colors.border_opacity};
`;